import { Link } from "react-router-dom";
import { Linkedin, Twitter, Facebook } from "lucide-react";
import { FOOTER } from "@/constants/testIds";
import { PROGRAMS } from "@/data/programs";
import { CONTACT_EMAIL, CONTACT_PHONE_DISPLAY, CONTACT_PHONE_TEL } from "@/lib/constants";

const ColHead = ({ children }) => (
  <div
    className="mb-4"
    style={{
      fontSize: 12,
      fontWeight: 600,
      color: "var(--color-label)",
      letterSpacing: "0.12em",
      textTransform: "uppercase",
    }}
  >
    {children}
  </div>
);

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={FOOTER.root}
      className="bg-white border-t"
      style={{ borderColor: "var(--color-border)" }}
    >
      <div className="container-wide py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <img
              src="/logo/smartedge-logo-navy.png"
              alt="SmartEdge Business Solutions"
              style={{ height: 44, width: "auto", display: "block" }}
            />
            <p className="type-caption mt-4 max-w-[280px]">
              Unlock hidden profitability through compliant tax strategies,
              wellness programs, and alternative revenue streams. Results-based.
              No upfront costs.
            </p>
          </div>

          <div>
            <ColHead>Quick links</ColHead>
            <ul className="flex flex-col gap-2">
              <li>
                <a href="/#how-it-works" className="type-caption" style={{ color: "var(--color-label)" }}>
                  How it works
                </a>
              </li>
              <li>
                <a href="/#programs" className="type-caption" style={{ color: "var(--color-label)" }}>
                  Programs
                </a>
              </li>
              <li>
                <a href="/#results" className="type-caption" style={{ color: "var(--color-label)" }}>
                  Results
                </a>
              </li>
              <li>
                <a href="/#contact" className="type-caption" style={{ color: "var(--color-label)" }}>
                  Contact
                </a>
              </li>
              <li>
                <Link to="/join-team" className="type-caption" style={{ color: "var(--color-label)" }}>
                  Join our team
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <ColHead>Programs</ColHead>
            <ul className="flex flex-col gap-2">
              {PROGRAMS.map((p) => (
                <li key={p.slug}>
                  <Link to={`/programs/${p.slug}`} className="type-caption" style={{ color: "var(--color-label)" }}>
                    {p.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <ColHead>Contact</ColHead>
            <ul className="flex flex-col gap-2">
              <li>
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  data-testid={FOOTER.emailLink}
                  className="type-caption"
                  style={{ color: "var(--color-label)" }}
                >
                  {CONTACT_EMAIL}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${CONTACT_PHONE_TEL}`}
                  data-testid={FOOTER.phoneLink}
                  className="type-caption"
                  style={{ color: "var(--color-label)" }}
                >
                  {CONTACT_PHONE_DISPLAY}
                </a>
              </li>
              <li className="type-caption">Mon – Fri · 9:00 AM – 5:00 PM ET</li>
            </ul>
          </div>
        </div>

        <hr className="hr-soft mt-12 mb-6" />

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="type-caption">
            © {year} SmartEdge Business Solutions. All rights reserved.
          </div>
          <div className="flex items-center gap-4" style={{ color: "var(--color-body)" }}>
            <a href="#" aria-label="LinkedIn" style={{ color: "inherit" }}>
              <Linkedin size={16} />
            </a>
            <a href="#" aria-label="Twitter" style={{ color: "inherit" }}>
              <Twitter size={16} />
            </a>
            <a href="#" aria-label="Facebook" style={{ color: "inherit" }}>
              <Facebook size={16} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
